<template>
  <section class="info defaultSectionMargins">
    <div class="container--Small">
      <h2 v-text="$t('info')" />
  
      <div v-if="data" class="info__Data">
        <template v-for="link in data">
          <Button v-if="link.page?.sef" type="nuxt-link" :to="link.page.sef" medium secondary>
            {{ link.cta_text }}
            <template #append>
              <Flare v-if="link.icon" :srcset="link.icon" size="both" width="32" height="32" crop="fill" :alt="link.icon" />
            </template>
          </Button>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {}
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_info.scss');
</style>